<div *ngIf="reportType === 'Office Rep -Briefly'">
  <div
    class="report-container"
    id="print-section"
    style="font-family: Arial, sans-serif; border: 1px solid black; margin: 0; padding: 0;margin-left: 30px;margin-right: 30px;margin-top: 30px;"
  >
    <!-- ===== HEADER SECTION ===== -->
    <table
      style="width: 100%; border-collapse: collapse; border: 1px solid black; background-color: #f8f9fa;"
    >
      <!-- <tr>
        <td style="font-size: 16px; font-weight: bold; text-align: left; white-space: nowrap; padding: 4px 6px;">
          हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक - पुस्तक विभाग
        </td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 4px 6px;">
          Book Payment Receipt Ledger
        </td>
        <td style="font-size: 14px; text-align: right; white-space: nowrap; padding: 4px 6px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td></td>
        <td style="font-size: 15px; font-weight: bold; text-align: center; padding: 2px 6px;">
          All Briefly Report
        </td>
        <td style="font-size: 14px; text-align: right; white-space: nowrap; padding: 2px 6px;">
          Date: {{ startDate | date:'dd-MM-yyyy' }} - {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr> -->

       <tr>
                    <th colspan="2" class="br-bottom br-leftt br-right br-top" style="border:none; font-size: 18px; font-weight: bold;border-bottom: 1px solid black;text-align: center;">
                        हिंदुस्तान प्रकाशन संस्था 
                    </th>
                    <th colspan="3" class="br-bottom br-right br-top" style="border:none; font-size: 18px;text-align: center;font-weight: bold;border-bottom: 1px solid black;">
                        Book Payment Receipt Report
                    </th>
                    <th colspan="4" class="br-bottom br-right br-top" style="border:none; font-size: 18px;border-bottom: 1px solid black;">
                        दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
                    </th>
                </tr>
                <tr>
                    <th colspan="2" class="br-bottom br-leftt br-right" style="border:none;font-size: 16px; font-weight: bold;">
                      विवेक पुस्तक प्रकाशन
                    </th>
                    <th colspan="3" class="br-bottom br-right" style="border:none; font-size: 16px;text-align: center;font-weight: bold;">
                       Office Rep -Briefly
                    </th>
                    <th colspan="4" class="br-bottom br-right" style="border:none; font-size: 16px;">
                        Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
                    </th>
                </tr>
    </table>

    <!-- ===== MAIN TABLE ===== -->
    <div class="table-responsive" style="margin: 0;">
      <table
    style="
      width: 100%;
      border-collapse: collapse;
      font-size: 15px;
      table-layout: fixed;
    "
  >
    <thead>
      <tr style="background-color: #f1f1f1; font-weight: bold; text-align: center;">
        <th style="border: 1px solid #000; padding: 10px; width: 70%;">Office Representative Name</th>
        <th style="border: 1px solid #000; padding: 10px; width: 30%;">Receipt Amount</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let office of PaymentBookOffInDFormBenas">
        <td style="border: 1px solid #000; padding: 8px;">
          {{ office.office_rep_name }}
        </td>

        <td style="border: 1px solid #000; padding: 8px; text-align: right;">
          {{ office.rep_total_rcv  }}
        </td>
      </tr>
    </tbody>

    <!-- ===== GRAND TOTAL ===== -->
    <tfoot>
      <tr style="background-color: #c8753f; font-weight: bold;">
        <td style="border: 1px solid #000; padding: 8px; text-align: right;">Grand Total:</td>
        <td style="border: 1px solid #000; padding: 8px; text-align: right;">
          {{ PaymentbookOffInDTotal2  }}
        </td>
      </tr>
    </tfoot>
  </table>
    </div>
  </div>

  <!-- ===== ACTION BUTTONS ===== -->
  <div class="button-container noPrint" style="margin-top: 10px; text-align: center;">
    <button mat-raised-button color="primary" (click)="exportExcel('Book_InDetail_Officewise')">📊 Export</button>
    <button mat-raised-button color="accent" (click)=" printPageA4()">🖨️ Print</button>
    <button mat-button mat-dialog-close>❌ Close</button>
  </div>
</div>
